define('prototypes/console',[],function(){
    return window['console'];
});
